import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createContext, type PropsWithChildren } from "react";
import type { CashierUserData } from "@/api/cashier";
import { getOrCreateCashierUserOptions } from "@/api/cashier/@tanstack/react-query.gen";
import { ErrorPage } from "@/components/error-page/ErrorPage";
import { useLogger } from "@/hooks/useLogger";
import { connectionStatus } from "@/api/connectionStatus/connectionStatus";
import { SkeletonLoadingScreen } from "@/components/skeleton-loading-screen/SkeletonLoadingScreen";

type CustomerDataContextType = UseQueryResult<CashierUserData, Error> & {
  data: CashierUserData;
};

export const CustomerDataContext = createContext<CustomerDataContextType>(
  {} as unknown as CustomerDataContextType
);

export const CustomerDataProvider = ({ children }: PropsWithChildren) => {
  const logger = useLogger();
  const queryResult = useQuery(getOrCreateCashierUserOptions());
  const conn = connectionStatus.getStatus();

  if (conn && queryResult.error) {
    logger.error("unable to load customer", { error: queryResult.error });
    return <ErrorPage buttonAction={() => queryResult.refetch()} />;
  }

  if (conn && (queryResult.isLoading || !queryResult.data)) {
    return (
      <div className="cashier-mfe-wrapper">
        <SkeletonLoadingScreen />
      </div>
    );
  }

  return (
    <CustomerDataContext.Provider
      value={queryResult as CustomerDataContextType}
    >
      {children}
    </CustomerDataContext.Provider>
  );
};
